import React, { memo } from 'react';
import { Text } from '@ui/atoms';
import ToolTip from '@ui/atoms/design-system/tool-tip';
import { cn } from '@ui/atoms/utils/utils';
import BondSectionTemplate from '@components/BondDirectoryFeature/feature/BondDetails/components/BondSectionTemplate';
import texts from '@components/BondDirectoryFeature/feature/BondDetails/en.json';

const KeyAttributes = ({ keyAttributes }) => {
    return (
        <BondSectionTemplate
            title={texts?.keyAttributes}
            className="pt-6 xl:pb-6"
        >
            <div className="flex flex-col gap-4 xl:max-w-[450px]">
                {keyAttributes?.map((keyAttribute, index) => (
                    <div key={index} className="flex gap-1">
                        <div className="flex items-center flex-1">
                            <ToolTip
                                content={keyAttribute?.tooltip}
                                placement="bottom-start"
                                interactive={false}
                            >
                                <Text
                                    content={keyAttribute.label}
                                    className="text-gray-500 p5-regular md:p4-regular"
                                />
                            </ToolTip>
                        </div>
                        <div className="flex items-center flex-1">
                            {keyAttribute?.options ? (
                                <OptionList
                                    options={keyAttribute.options}
                                    selectedValue={keyAttribute.value}
                                />
                            ) : (
                                <Text
                                    content={keyAttribute?.value}
                                    className="p5-medium md:p4-medium text-basicBlack px-2 py-1"
                                />
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </BondSectionTemplate>
    );
};

const OptionList = ({ options, selectedValue }) => (
    <div className="flex items-center border rounded-full">
        {options.map((option, index) => (
            <div
                key={index}
                className={cn(
                    'flex flex-col items-start justify-start p5-regular md:p4-regular text-gray-500 flex-1 gap-1 bg-basicWhite px-2 py-1 rounded-full',
                    {
                        'bg-secondary-200 p5-medium md:p4-medium text-basicBlack':
                            selectedValue === option,
                    }
                )}
            >
                <Text content={option === texts.SeniorityOptions.NonSenior ? texts.SeniorityOptions.NonDashSenior : option} className="whitespace-nowrap" />
            </div>
        ))}
    </div>
);

export default memo(KeyAttributes);
